<template>
  <div class="payment-result-page white-theme">
    <div class="result-card">
      <div class="result-icon cancel">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
      </div>
      <h1 class="result-title">{{ $t('payment.cancel.title') }}</h1>
      <p class="result-message">{{ $t('payment.cancel.message') }}</p>
      <div class="result-actions">
        <router-link to="/pricing" class="btn btn-primary btn-lg">{{ $t('payment.cancel.tryAgain') }}</router-link>
        <router-link to="/" class="btn btn-secondary btn-lg">{{ $t('payment.cancel.goHome') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import GA from '@/utils/ga'

export default {
  name: 'PaymentCancel',
  mounted() {
    var userInfo = this.$store.state.userInfo
    GA.paymentCancel(userInfo ? userInfo.id : '')
  }
}
</script>

<style scoped>
.payment-result-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}
.result-card {
  max-width: 480px;
  text-align: center;
  padding: 48px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
}
.result-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.result-icon.cancel {
  background: rgba(255, 152, 0, 0.1);
  color: #ff9800;
}
.result-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}
.result-message {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 32px;
}
.result-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
